'use es6';

const getRoot = ({
  comparisonTool = {}
} = {}) => comparisonTool;
const getComparisonToolSearches = state => getRoot(state).comparisonToolSearches || {};
export const getComparisonToolFormDefinition = (state, guid, startTimestamp, endTimestamp) => {
  const form = getComparisonToolSearches(state)[JSON.stringify({
    guid,
    startTimestamp,
    endTimestamp
  })];
  return form && form.REQUEST_STATE.isSuccessful() && form.form || null;
};
export const getComparisonToolFormDefinitionForPreview = (state, guid) => {
  const form = getComparisonToolSearches(state)[guid];
  return form && form.REQUEST_STATE.isSuccessful() && form.form || null;
};
export const getStoredDashboardQuery = state => getRoot(state).storedDashboardQuery;